import { setGAUserId } from '../utils/analytics';
import { getFormattedUserName } from '../utils/functions/common';
import { TUser } from '../utils/types/agrocraftArtisan';
import { emptySplitApi } from './base/emptySplitApi';
import { updateAuthUser } from './slices/authUserSlice';

export const userService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserDetails: builder.query<TUser, void>({
      query: () => ({
        url: 'app-users/current-user',
        method: 'GET',
      }),
      async onQueryStarted(
        args,
        { dispatch, queryFulfilled }
      ) {
        queryFulfilled
          .then((data) => {
            dispatch(updateAuthUser(data?.data));
            setGAUserId(data?.data?.id?.toString());
          })
          .catch((error) => error);
      },
    }),
    getUserList: builder.query<TUser[], void>({
      query: () => ({
        url: 'user/fetchAllUsersByRoleAccess',
        method: 'GET',
      }),
      transformResponse: (data: TUser[]) => {
        return data.map((user) => ({
          ...user,
          full_name:
            getFormattedUserName(user.full_name)?.name ||
            user.full_name,
        }));
      },
    }),
  }),
});

export const {
  useGetUserDetailsQuery,
  useLazyGetUserListQuery,
} = userService;
